/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ManualLiquidation,
  ManualLiquidationInterface,
} from "../ManualLiquidation";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_repository",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "InvalidSiloRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "NotSilo",
    type: "error",
  },
  {
    inputs: [],
    name: "RepayFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "UsersMustMatchSilos",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "silo",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "LiquidationExecuted",
    type: "event",
  },
  {
    inputs: [],
    name: "SILO_REPOSITORY",
    outputs: [
      {
        internalType: "contract ISiloRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
    ],
    name: "executeLiquidation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_assets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_receivedCollaterals",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "_shareAmountsToRepaid",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "_flashReceiverData",
        type: "bytes",
      },
    ],
    name: "siloLiquidationCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type ManualLiquidationConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ManualLiquidationConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ManualLiquidation__factory extends ContractFactory {
  constructor(...args: ManualLiquidationConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ManualLiquidation";
  }

  deploy(
    _repository: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ManualLiquidation> {
    return super.deploy(
      _repository,
      overrides || {}
    ) as Promise<ManualLiquidation>;
  }
  getDeployTransaction(
    _repository: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_repository, overrides || {});
  }
  attach(address: string): ManualLiquidation {
    return super.attach(address) as ManualLiquidation;
  }
  connect(signer: Signer): ManualLiquidation__factory {
    return super.connect(signer) as ManualLiquidation__factory;
  }
  static readonly contractName: "ManualLiquidation";
  public readonly contractName: "ManualLiquidation";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ManualLiquidationInterface {
    return new utils.Interface(_abi) as ManualLiquidationInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ManualLiquidation {
    return new Contract(address, _abi, signerOrProvider) as ManualLiquidation;
  }
}
